import { colors, fonts } from '@grupoboticario/flora-tokens/dist/revendedores/web/ds'

export const revendedores = {
  colors,
  fonts,
}
